module.exports = __webpack_public_path__ + "img/timeline.6374b822.png";